
export const accordions = ($productTemplate) => {
    const accordions = document.querySelectorAll(".product-template__accordion");
    
    accordions.forEach(currentAccordion => {
        const trigger = currentAccordion.querySelector(".product-template__accordion-trigger");
        const content = currentAccordion.querySelector(".product-template__accordion-content");
        const plus = trigger.querySelector(".icon-plus");
        const minus = trigger.querySelector(".icon-minus");

        trigger.addEventListener("click", () => {
            // Hide inactive accordions
            accordions.forEach(accordion => {
                const trigger = accordion.querySelector(".product-template__accordion-trigger");
                const content = accordion.querySelector(".product-template__accordion-content");
                const plus = trigger.querySelector(".icon-plus");
                const minus = trigger.querySelector(".icon-minus");
        
               plus.classList.remove("hidden");
               minus.classList.add("hidden");
               content.classList.add("hidden");
            });

            // Reveal clicked accordion
            plus.classList.add("hidden");
            minus.classList.remove("hidden");
            content.classList.remove("hidden");
        });
    });

};

export default accordions;
